import React from 'react';

export default class Popup extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("Popup", this.props)

		const { title, body, children, onHidePopup, style } = this.props;

		return (
			<div className="Popup">
				<div className="card">
					<div className="card-body">
						<section>
							{/* For the title prop, use an h1 or span element and style as you desire */}
							{title}
							<div className="x-mark" onClick={onHidePopup}>
								<i className="fas fa-times" />
							</div>
						</section>
						<hr />
						<div className="mt-2">{body}</div>
						<div style={style}>{children}</div>
					</div>
				</div>
			</div>
		);
	}
}
